/* WorkTriggerScheduleTabComponent.js */

"use strict";
const Renderer = require("./WorkTriggerScheduleTabRenderer");

class WorkTriggerScheduleTabComponent {
    constructor(workTriggerDetailsView) {
        this._renderer = new Renderer(workTriggerDetailsView);
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        return Promise.resolve();
    }
}
module.exports = WorkTriggerScheduleTabComponent;
